import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-e-pagination',
  templateUrl: './e-pagination.component.html',
  styleUrl: './e-pagination.component.scss',
})
export class EPaginationComponent {
  @Input() totalPages!: number;
  @Output() pageChange = new EventEmitter<number>();

  changePage(page: number) {
    this.pageChange.emit(page);
  }
}
